import { CustomDSValidators } from './../shared/validators/custom-validators';
import { IpmiService } from './../services/ipmi.service';
import { ApiService} from './../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ResponseService } from '../services/response.service';


@Component({
  selector: 'app-server-ipmi',
  templateUrl: './server-ipmi.component.html'
})
export class ServerIpmiComponent implements OnInit {

  allowedMyIP: boolean;
  IPMIAccessForm: FormGroup;
  IPMIData = <any>{};

  constructor(
    private ipmiService: IpmiService,
    private router: ActivatedRoute,
    private apiService: ApiService,
    private responseService: ResponseService
  ) {
    this.IPMIAccessForm = new FormGroup({
      allowed_ip: new FormControl('', [Validators.required, CustomDSValidators.IPWithMask]),
      id: new FormControl(null)
    });
  }

  ngOnInit() {
    this.getIPMIData();
    this.accessForCurrentIP();
  }

  accessForAll () {
    this.IPMIAccessForm.controls['allowed_ip'].setValue('0.0.0.0');
    this.allowedMyIP = false;
  }

  accessForCurrentIP () {
    this.apiService.get('/current_ip').subscribe(
      response => { 
        const ip = this.responseService.success(false, response, 'ip');
        this.IPMIAccessForm.controls['allowed_ip'].setValue(ip);
        this.allowedMyIP = true;
      }
    );
  }

  getIPMIData () {
    this.router.params.subscribe(params => {
      this.IPMIAccessForm.controls['id'].setValue(params['server_id']);
      this.ipmiService.ipmiServer(params['server_id']).subscribe(
        (ipmiData) => {
          this.IPMIData = ipmiData;
        },
        (error) => {
          // console.log('ERROR');
          // console.log(error);
        }
      );
    });
  }

  getIPMIAccess() {
    this.ipmiService.startNAT(this.IPMIAccessForm.value);
    this.getIPMIData();
  }

  stopNAT () {
    this.ipmiService.stopNAT(this.IPMIAccessForm.controls['id'].value);
    this.getIPMIData();
  }
}



// WEBPACK FOOTER //
// ./src/app/server/server-ipmi.component.ts